import {API_BASE} from '../apiConfig';

const DEV_LOGIN_PARAM = 'devLogin';

// Автовход для локальной разработки: http://localhost:3000/?devLogin=<ник>
// логинит под dev-пользователем через POST /auth/dev-login (роут есть только
// вне production) и убирает параметр из адреса. Работает только в dev-сборке
// CRA (npm start): в production-бандле NODE_ENV вшит как 'production', и
// функция ничего не делает. Ошибки глотаем — тогда приложение откроется как
// обычно, на экране входа.
export const runDevAutoLogin = async () => {
  if (process.env.NODE_ENV !== 'development') return false;

  const url = new URL(window.location.href);
  const name = url.searchParams.get(DEV_LOGIN_PARAM);
  if (!name) return false;

  url.searchParams.delete(DEV_LOGIN_PARAM);
  window.history.replaceState(null, '', url.pathname + url.search + url.hash);

  try {
    const res = await fetch(`${API_BASE}/auth/dev-login`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
      body: JSON.stringify({name}),
    });
    return res.ok;
  } catch {
    return false;
  }
};
